var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#FD6925"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0631 5.37724V9.05801L9.87542 10.8984L6.68774 9.05801V5.37725L9.87542 3.53687L13.0631 5.37724Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2755 10.9126V14.5934L13.0878 16.4338L9.90015 14.5934V10.9126L13.0878 9.07227L16.2755 10.9126Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87535 10.8985V14.5793L6.68768 16.4196L3.5 14.5793V10.8985L6.68768 9.05811L9.87535 10.8985Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67688 16.4544V9.02338L9.83985 7.19727L16.2754 10.9128L9.90002 14.5935L6.68764 12.7389L6.67689 16.4544",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90015 7.1626V10.8843",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84876 7.19212L13.0719 5.33126L9.90002 3.5L6.67688 5.36086L9.84876 7.19212Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67689 12.7451L9.90003 10.8842L6.72815 9.05298L3.505 10.9138L6.67689 12.7451Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86462 14.5729L13.0878 16.4338V12.7713L9.86462 10.9104V14.5729Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.32524deee0cc3ad593ab761b74c573e9.svg";
export { ForwardRef as ReactComponent };